<template>
  <div
    id="app"
    class="wrapper"
    :class="isMobile ? 'mobile' : ''"
    :style="
      !isMobile
        ? { 'background-image': 'url(' + url + background.desktop + ')' }
        : ''
    "
  >
    <slot />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Default",
  data() {
    return { url: process.env.VUE_APP_BACKEND };
  },
  computed: {
    ...mapGetters({
      background: "getBackground",
    }),
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center center;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparentize($color: white, $amount: 0.2);
  }
}
.mobile {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: normal;
  background-color: $bg-color;
}
</style>
